module.exports = __webpack_public_path__ + "static/img/course_1.d7a901f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sample/course_1.jpg
// module id = EO2F
// module chunks = 1